// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"c16aa4f9","371":"7c2a596f","482":"262913b0"}[chunkId] + ".chunk.js";
};